export const ACTION_APP_LOADING_START = 'ACTION_APP_LOADING_START';
export const ACTION_APP_LOADING_END = 'ACTION_APP_LOADING_END';

export const appLoadingAction = ()=>{
    return {type: ACTION_APP_LOADING_START};
};

export const appEndLoadingAction = ()=>{
    return {type: ACTION_APP_LOADING_END};
};


// WEBPACK FOOTER //
// ./src/App/actions.js